document.addEventListener('DOMContentLoaded', () => {
  function getSelectedAddonCheckboxes() {
    return document.querySelectorAll('[id^="buy-more-body-"] .product-addons__select-checkbox:checked');
  }

  function getMainVariantId(formEl) {
    const enabledVariantInput = formEl.querySelector('input[name="id"]:not([disabled])');
    const fallbackVariantInput = formEl.querySelector('input[name="id"]');
    const input = enabledVariantInput || fallbackVariantInput;
    return input ? input.value : '';
  }

  function getMainQuantity(formEl) {
    const quantityInput = formEl.querySelector('input[name="quantity"]');
    return quantityInput ? parseInt(quantityInput.value, 10) || 1 : 1;
  }

  function setButtonsLoadingState(isLoading) {
    const buttons = [document.getElementById('real-add-to-cart')];
    buttons.forEach((button) => {
      if (!button) return;
      if (isLoading) {
        button.dataset.wasDisabledBeforeSubmit = button.disabled ? 'true' : 'false';
        button.setAttribute('aria-busy', 'true');
        button.setAttribute('disabled', 'disabled');
      } else {
        button.removeAttribute('aria-busy');
        if (button.dataset.wasDisabledBeforeSubmit !== 'true') {
          button.removeAttribute('disabled');
        }
        delete button.dataset.wasDisabledBeforeSubmit;
      }
    });
  }

  async function handleBundledAddToCart(form) {
    const addonCheckboxes = getSelectedAddonCheckboxes();
    if (!addonCheckboxes.length) return false;

    const mainVariantId = getMainVariantId(form);
    if (!mainVariantId) return false;

    // Keep line-item properties in sync with native ProductForm submit behavior.
    const productFormComponent = form.closest('product-form');
    if (productFormComponent && typeof productFormComponent.updateDeliveryEstimateField === 'function') {
      productFormComponent.updateDeliveryEstimateField();
    }

    const mainQty = getMainQuantity(form);
    const items = [{ id: Number(mainVariantId), quantity: mainQty }];

    addonCheckboxes.forEach((checkbox) => {
      const addonVariantId = checkbox.value;
      if (addonVariantId) {
        items.push({ id: Number(addonVariantId), quantity: 1 });
      }
    });

    const formData = new FormData(form);
    const properties = {};
    formData.forEach((value, key) => {
      const match = key.match(/^properties\[(.*)\]$/);
      if (match && value != null && String(value).trim() !== '') {
        properties[match[1]] = value;
      }
    });
    if (Object.keys(properties).length > 0) {
      items[0].properties = properties;
    }

    const sellingPlan = formData.get('selling_plan');
    if (sellingPlan) {
      items[0].selling_plan = sellingPlan;
    }

    setButtonsLoadingState(true);
    const cartAddUrl = (window.theme && window.theme.routes && window.theme.routes.cartAdd) ? window.theme.routes.cartAdd : '/cart/add.js';

    try {
      const response = await fetch(cartAddUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({ items })
      });
      const data = await response.json();
      if (!response.ok || (data && data.status && data.status !== 200)) {
        if (data && data.description) {
          alert(data.description);
        }
        return true;
      }

      addonCheckboxes.forEach((checkbox) => {
        checkbox.checked = false;
      });

      const opener = document.activeElement || document.getElementById('real-add-to-cart') || null;
      const cartDrawerEl = document.querySelector('cart-drawer');
      if (cartDrawerEl && typeof cartDrawerEl.refresh === 'function') {
        cartDrawerEl.refresh();
      }
      document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh'));
      document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open', {
        detail: { opener }
      }));
      return true;
    } catch (error) {
      // Keep silent to match existing addon add-to-cart behavior.
      return true;
    } finally {
      setButtonsLoadingState(false);
      updateAddToCartButtonText();
    }
  }

  function updateAddToCartButtonText() {
    const realButton = document.getElementById('real-add-to-cart');
    const form = document.querySelector('.js-product-form-main');
    if (!realButton || !form) return;
    if (realButton.disabled) return;

    const defaultText = realButton.getAttribute('data-add-to-cart-text') || realButton.textContent.trim();
    const itemsTemplate = realButton.getAttribute('data-add-to-cart-items-text');
    const mainQty = getMainQuantity(form);
    const addonCheckboxes = getSelectedAddonCheckboxes();
    const addonCount = addonCheckboxes.length;
    const totalItems = mainQty + addonCount;

    let text = defaultText;
    if (totalItems > 1 && itemsTemplate) {
      text = itemsTemplate.replace(/__COUNT__/g, String(totalItems));
    }

    if (realButton.textContent.trim() !== text) {
      realButton.textContent = text;
    }
  }

  const form = document.querySelector('.js-product-form-main');
  if (form) {
    form.addEventListener('change', (e) => {
      if (e.target.name === 'quantity') {
        updateAddToCartButtonText();
      }
    });
    form.addEventListener('input', (e) => {
      if (e.target.name === 'quantity') {
        updateAddToCartButtonText();
      }
    });
  }

  document.addEventListener('submit', (e) => {
    const targetForm = e.target;
    if (!targetForm || !targetForm.matches || !targetForm.matches('.js-product-form-main')) return;
    const hasSelectedAddons = getSelectedAddonCheckboxes().length > 0;
    if (!hasSelectedAddons) return;

    // Stop native/theme handlers immediately to avoid duplicate main-product adds.
    e.preventDefault();
    e.stopPropagation();
    if (typeof e.stopImmediatePropagation === 'function') {
      e.stopImmediatePropagation();
    }

    handleBundledAddToCart(targetForm);
  }, true);

  document.addEventListener('change', (e) => {
    const isAddonCheckbox = e.target.type === 'checkbox' && e.target.closest && e.target.closest('[id^="buy-more-body-"]');
    if (isAddonCheckbox) {
      updateAddToCartButtonText();
    }
  });

  updateAddToCartButtonText();

  document.querySelectorAll('[data-review-language]').forEach((el) => {
    const lang = el.getAttribute('data-review-language');
    if (lang && !el.hasAttribute('lang')) {
      el.setAttribute('lang', lang);
    }
  });

  (function initPromoExpiryCountdown() {
    const countdownEls = document.querySelectorAll('[data-promo-expiry-countdown]');
    if (!countdownEls.length) return;

    const pad2 = (n) => String(n).padStart(2, '0');

    countdownEls.forEach((countdownEl) => {
      const endMsRaw = countdownEl.dataset.endMs;
      if (!endMsRaw) return;

      const endMs = parseInt(endMsRaw, 10);
      if (!Number.isFinite(endMs)) return;

      const maxSecondsRaw = countdownEl.dataset.maxSeconds;
      const maxSeconds = Number.isFinite(parseInt(maxSecondsRaw, 10)) ? parseInt(maxSecondsRaw, 10) : 1209600;

      const daysEl = countdownEl.querySelector('.js-days');
      const hoursEl = countdownEl.querySelector('.js-hours');
      const minsEl = countdownEl.querySelector('.js-mins');
      const secsEl = countdownEl.querySelector('.js-secs');
      if (!daysEl || !hoursEl || !minsEl || !secsEl) return;

      let timerId;

      function hideCountdown() {
        countdownEl.hidden = true;
        if (timerId) window.clearInterval(timerId);
      }

      function tick() {
        const secsLeft = Math.floor((endMs - Date.now()) / 1000);
        if (secsLeft <= 0 || secsLeft > maxSeconds) {
          hideCountdown();
          return;
        }

        const days = Math.floor(secsLeft / 86400);
        const hours = Math.floor((secsLeft % 86400) / 3600);
        const mins = Math.floor((secsLeft % 3600) / 60);
        const secs = secsLeft % 60;

        daysEl.textContent = String(days);
        hoursEl.textContent = pad2(hours);
        minsEl.textContent = pad2(mins);
        secsEl.textContent = pad2(secs);
      }

      tick();
      timerId = window.setInterval(tick, 1000);
    });
  })();
});
